import {useHomeStyles} from "../../../../shared/styles/HomeStyles";
import useScreenWidth from "../../../../shared/hooks/useScreenWidth";
import {Box, Link, Typography} from "@mui/material";
import {LinkBlockProps} from "../../models/sliders";

export const LinkBlock = ({ actionOnClick, image, textTitle, validation = false }: LinkBlockProps) => {
  const classes = useHomeStyles()
  const isMobile = useScreenWidth(700)

  return (
    <Link component="div" sx={classes.containerCard}>
      <Box onClick={actionOnClick} sx={{ ...classes.containercarousel, cursor: 'pointer' }}>
        <Box
          position="relative"
          overflow="hidden"
          height={isMobile ? '120px' : validation ? '8.75rem' : '17.5rem'}
        >
          <Box
            sx={{
              ...classes.bodyImage,
              ...(isMobile
                ? {
                  borderRadius: 8,
                  backgroundImage: `url(${image})`
                }
                : {
                  backgroundImage: `url(${image})`,
                })
            }}
          />
        </Box>
        <Box sx={classes.bodyText}>
          <Box sx={classes.contentText}>
            <Typography sx={classes.titleLink}>{textTitle}</Typography>
          </Box>
        </Box>
      </Box>
    </Link>
  )
}
